import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../hooks/useLogout";
import { useFieldArray, useForm } from "react-hook-form";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Col,
    Icon,
    PreviewAltCard,
    Row,
} from "../../../components/Component";
import { Form, Spinner } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MySelect from "../../../MyComp/UI/form/MySelect";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MyDate from "../../../MyComp/UI/form/MyDate";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyGST from "../../../MyComp/UI/form/MyGST";
import moment from "moment";
import DateComponent from "../../../MyComp/UI/form/DateComponent";
import { getLabDetailsAPI, labApprovalAPI } from "../../../api/lab";
import { toast } from "react-toastify";
import { getZipDetailsAPI } from "../../../api/master/indes";
import { BASE_URL_IMG } from "../../../assets/constants";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import { updateLabEdit } from "../../../api/lab";

// CSS for red border styling
const objectionStyles = `
  .objection-field {
    position: relative;
  }
  
  .objection-field input,
  .objection-field select,
  .objection-field textarea,
  .objection-field .form-control,
  .objection-field .react-select__control,
  .objection-field .css-13cymwt-control,
  .objection-field .css-t3ipsp-control,
  .objection-field .input-group,
  .objection-field .form-control:focus,
  .objection-field input:focus,
  .objection-field select:focus {
    border: 2px solid #ff0000 !important;
    box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.1) !important;
  }
  
  .objection-field label,
  .objection-field .form-label {
    color: #ff0000 !important;
    font-weight: 600 !important;
  }
  
  /* For image upload components */
  .objection-image-upload {
    border: 2px solid #ff0000 !important;
    border-radius: 4px !important;
    padding: 5px !important;
    display: inline-block;
  }
  
  .objection-error-message {
    color: #ff0000;
    font-size: 12px;
    margin-top: 5px;
    font-weight: 500;
  }
  
  /* Red border for image upload area */
  .objection-field .image-upload-container {
    border: 2px solid #ff0000 !important;
    border-radius: 4px !important;
    padding: 8px;
  }
`;

const LabDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useLogout();
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: false,
            agreed: false,
            qualificationDD: [],
            specializationDD: [],

            objectionKeys: [],
            approvedKeys: [],

            pan_image: null,
            pan: null,

            nabl_certificate: null,
            nabl_certificate_img: null,

            nabh_certificate: null,
            nabh_certificate_img: null,

            other_certificate: null,
            other_certificate_img: null,

            lab_license: [
                {
                    certificate: null,
                    certificate_url: null,
                },
            ],

            passbook: null,
            passbook_image: null,

            lab: [
                {
                    image: null,
                    image_url: null,
                },
            ],
            mode: location?.state?.mode || "Add",
            actionType: null,
        },
    });
    const { fields, append, remove } = useFieldArray({
        control,
        name: "lab_license",
    });

    const {
        fields: labFields,
        append: labAppend,
        remove: labRemove,
    } = useFieldArray({
        control,
        name: "lab",
    });

    const [mode, setMode] = useState(location?.state?.mode || "Add");
    const doctorId = location?.state?.doctorId || "";
    const queryParams = new URLSearchParams(location.search);
    const labId = queryParams.get("labId");
    const isLoading = watch("isLoading");
    const [data, setData] = useState({});
    const [imageOpen, setImageOpen] = useState(false);
    console.log(mode, "mode..")

    // Function to check if a field is in objection keys
    const isFieldObjection = (fieldName, index = null) => {
        if (!data || !data.keys || !Array.isArray(data.keys)) {
            return false;
        }

        // Check exact match
        if (data.keys.includes(fieldName)) {
            console.log(`Field ${fieldName} is rejected`);
            return true;
        }

        // Check with array index pattern
        if (index !== null && index !== undefined) {
            const arrayFieldName = `${fieldName}[${index}]`;
            if (data.keys.includes(arrayFieldName)) {
                console.log(`Field ${arrayFieldName} is rejected`);
                return true;
            }

            const nestedFieldName = `${fieldName}.${index}`;
            if (data.keys.includes(nestedFieldName)) {
                console.log(`Field ${nestedFieldName} is rejected`);
                return true;
            }
        }

        return false;
    };

    // Function to get dynamic class names for objection fields
    const getFieldClassName = (fieldName, index = null, baseClass = "") => {
        const isObjection = isFieldObjection(fieldName, index);
        return `${baseClass} ${isObjection ? 'objection-field' : ''}`.trim();
    };

    // Function to get objection prop for child components
    const getObjectionProp = (fieldName, index = null) => {
        return isFieldObjection(fieldName, index);
    };

    const handleImageOpenPreview = (row) => {
        const imageUrl = `${row?.image}`;
        setValue("image_preview", imageUrl);
        setImageOpen(true);
    };

    useEffect(() => {
        getLabDetail();
    }, []);

    function parseTimeToDate(timeString) {
        const date = new Date();

        if (/AM|PM/i.test(timeString)) {
            const [time, modifier] = timeString.split(/ (AM|PM)/i);
            let [hours, minutes] = time.split(":").map(Number);

            if (modifier.toUpperCase() === "PM" && hours < 12) {
                hours += 12;
            }
            if (modifier.toUpperCase() === "AM" && hours === 12) {
                hours = 0;
            }

            date.setHours(hours);
            date.setMinutes(minutes);
        } else {
            const [hours, minutes] = timeString.split(":").map(Number);
            date.setHours(hours);
            date.setMinutes(minutes);
        }

        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }

    const getLabDetail = () => {
        const body = {
            labId: labId,
        };
        getLabDetailsAPI(body)
            .then((res) => {
                if (res.data.status === true) {
                    const lab = res.data.data;
                    toast.clearWaitingQueue();
                    console.log("data", lab);
                    console.log("Objection Keys (Rejected Fields):", lab.keys);
                    setData(lab);

                    //!Step one form details
                    setValue("name", lab?.name || "");
                    setValue("mobile", lab?.mobile || "");
                    setValue("contact_number", lab?.contact_number || "");
                    setValue("alt_contact_number", lab?.alt_contact_number || "");
                    setValue("pincode", lab?.pincode || "");
                    trigger("pincode");
                    setValue("address", lab?.address || "");
                    setValue("person_name", lab?.person_name || "");
                    setValue("latitude", lab.latitude)
                    setValue("longitude", lab.longitude)
                    setValue("map_link", lab?.map_link || "");
                    setValue("lab_type", lab?.lab_type || "");
                    setValue("email", lab.email || "");
                    setValue("address", lab.address);

                    //!step two details
                    setValue("nablId", lab?.nablId || "");
                    setValue("nabhId", lab?.nabhId || "");
                    setValue("otherIds", lab?.otherIds || "");
                    setValue("gstNumber", lab?.gst_number || "");
                    setValue("licenseNumber", lab?.license_no || "");

                    if (lab?.nablEndDate) {
                        const dob = moment(
                            lab?.nablEndDate,
                            ["DD/MM/YYYY", "YYYY-MM-DD"],
                            true
                        );

                        if (dob.isValid()) {
                            setValue("nablEndDate", dob.toDate());
                        }
                    }
                    if (lab?.nabhEndDate) {
                        const dob = moment(
                            lab?.nabhEndDate,
                            ["DD/MM/YYYY", "YYYY-MM-DD"],
                            true
                        );

                        if (dob.isValid()) {
                            // setValue("nabhEndDate", dob.toDate());
                        }
                    }
                    if (lab?.otherEndDate) {
                        const dob = moment(
                            lab?.otherEndDate,
                            ["DD/MM/YYYY", "YYYY-MM-DD"],
                            true
                        );

                        if (dob.isValid()) {
                            // setValue("otherEndDate", dob.toDate());
                        }
                    }
                    setValue("isNablCertified", lab.nabl_certified);
                    setValue("nablId", lab.nablId);
                    setValue("nabl_certificate_img", `${BASE_URL_IMG}${lab.nabl_certificate}`);
                    setValue("cmo_image", `${BASE_URL_IMG}${lab.cmo_certificate}`);
                    setValue("cmo", `${BASE_URL_IMG}${lab.cmo_certificate}`);
                    setValue("cmoNumber", lab.cmoCertificateNumber);
                    setValue("nabl_certificate", lab?.nabl_certificate ? `${BASE_URL_IMG}${lab?.nabl_certificate}` : null);
                    setValue("nabh_certificate", lab?.nabh_certificate ? `${BASE_URL_IMG}${lab?.nabh_certificate}` : null);
                    setValue("other_certificate", lab?.other_certificate ? `${BASE_URL_IMG}${lab?.other_certificate}` : null);

                    if (lab.license_documents && Array.isArray(lab.license_documents)) {
                        remove();
                        lab?.license_documents?.forEach((item) => {
                            append({
                                certificate: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
                                certificate_url: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
                            });
                        });
                    }

                    //! step 3 details
                    setValue("service_pincode", lab?.labservices?.pincode || "");
                    setValue("radius", lab?.labservices?.radius || "");
                    setValue("service", lab?.labservices?.service || "");
                    const sTime24 = lab?.labservices?.startTime;
                    const parsedTime = sTime24 ? parseTimeToDate(sTime24) : null;
                    const eTime24 = lab?.labservices?.endTime;
                    const parsedETime = eTime24 ? parseTimeToDate(eTime24) : null;
                    setValue("startTime", lab?.startTime || "")
                    setValue("endTime", lab?.endTime || "")
                    // setValue("startTime", lab?.labservices?.startTime ? new Date(parsedTime) : null);
                    // setValue("endTime", lab?.labservices?.endTime ? new Date(parsedETime) : null);

                    //! step 4 details
                    setValue("bankName", lab?.bankName || "");
                    setValue("accountNumber", lab?.accountNumber || "");
                    setValue("ifscCode", lab?.ifscCode || "");
                    setValue("pan_image", `${BASE_URL_IMG}${lab.pan}`);
                    setValue("upiId", lab?.upiId || "");
                    setValue("passbook_image", lab.passbook ? `${BASE_URL_IMG}${lab.passbook}` : null);

                    if (lab.lab_images && Array.isArray(lab.lab_images)) {
                        labRemove();
                        lab?.lab_images?.forEach((item) => {
                            labAppend({
                                image: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
                                image_url: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
                            });
                        });
                    }

                    setValue("isLoading", false);
                } else if (res.data.status === false) {
                    setValue("isLoading", false);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    setValue("isLoading", false);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                setValue("isLoading", false);
                toast.error(err?.response?.data?.message);
            });
    };

    useEffect(() => {
        if (watch("pincode") && watch("pincode").toString().length === 6) {
            const body = {
                pin_code: watch("pincode"),
            };
            getZipDetails(body);
        }
    }, [watch("pincode")]);

    const getZipDetails = (body) => {
        getZipDetailsAPI(body)
            .then((res) => {
                if (res.data.status === true) {
                    const responseData = res.data.data[0];
                    console.log("zip details", responseData);
                    setValue("city", responseData.district_name);
                    setValue("state", responseData.state_name);
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else if (res.data.status === false) {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
            });
    };

    const onFormSubmit = async (formData) => {
        try {
            setValue("isLoading", true);

            const fd = new FormData();

            // BASIC DETAILS
            fd.append("labId", labId);
            fd.append("name", formData.name || "");
            fd.append("mobile", formData.mobile || "");
            fd.append("email", formData.email || "");
            fd.append("contact_number", formData.contact_number || "");
            fd.append("alt_contact_number", formData.alt_contact_number || "");
            fd.append("pincode", formData.pincode || "");
            fd.append("city", formData.city || "");
            fd.append("state", formData.state || "");
            fd.append("address", formData.address || "");
            fd.append("person_name", formData.person_name || "");
            fd.append("map_link", formData.map_link || "");
            fd.append("latitude", formData.latitude || "");
            fd.append("longitude", formData.longitude || "");

            // LAB TYPE (multi select)
            if (formData?.lab_type && Array.isArray(formData.lab_type)) {
                formData.lab_type.forEach((item, index) => {
                    fd.append(`lab_type[${index}]`, item.value || item);
                });
            }

            // SERVICE
            fd.append("service", formData.service || "");
            fd.append("radius", formData.radius || "");
            fd.append("startTime", formData.startTime || "");
            fd.append("endTime", formData.endTime || "");

            // BANK
            fd.append("bankName", formData.bankName || "");
            fd.append("accountNumber", formData.accountNumber || "");
            fd.append("ifscCode", formData.ifscCode || "");
            fd.append("upiId", formData.upiId || "");

            // PASSBOOK
            if (formData.passbook instanceof File) {
                fd.append("passbook", formData.passbook);
            } else if (typeof formData.passbook === "string" && formData.passbook) {
                fd.append("passbook", formData.passbook);
            }

            // PAN
            if (formData.pan instanceof File) {
                fd.append("pan", formData.pan);
            } else if (typeof formData.pan === "string" && formData.pan) {
                fd.append("pan", formData.pan);
            }

            // NABL
            fd.append("nabl_certified", formData.isNablCertified || false);

            if (formData.isNablCertified) {
                fd.append("nablId", formData.nablId || "");

                if (formData.nabl_certificate instanceof File) {
                    fd.append("nabl_certificate", formData.nabl_certificate);
                } else if (typeof formData.nabl_certificate === "string") {
                    fd.append("nabl_certificate", formData.nabl_certificate);
                }
            }

            // OTHER
            fd.append("otherIds", formData.otherIds || "");

            if (formData.other_certificate_img instanceof File) {
                fd.append("other_certificate_img", formData.other_certificate_img);
            } else if (typeof formData.other_certificate_img === "string") {
                fd.append("other_certificate_img", formData.other_certificate_img);
            }

            // GST / LICENSE / CMO
            fd.append("gstNumber", formData.gstNumber || "");
            fd.append("licenseNumber", formData.licenseNumber || "");
            fd.append("cmoNumber", formData.cmoNumber || "");

            if (formData.cmo instanceof File) {
                fd.append("cmo_certificate", formData.cmo);
            }

            // LAB LICENSE FILES
            if (formData?.lab_license && Array.isArray(formData.lab_license)) {
                formData.lab_license.forEach((item, index) => {
                    if (item?.certificate instanceof File) {
                        fd.append(`lab_license[${index}].certificate`, item.certificate);
                    } else if (typeof item?.certificate === "string") {
                        fd.append(`lab_license[${index}].certificate_url`, item.certificate);
                    }
                });
            }

            // LAB IMAGES
            if (formData?.lab && Array.isArray(formData.lab)) {
                formData.lab.forEach((item, index) => {
                    if (item?.image instanceof File) {
                        fd.append(`lab[${index}].image`, item.image);
                    } else if (typeof item?.image === "string") {
                        fd.append(`lab[${index}].image_url`, item.image);
                    }
                });
            }

            // DEBUG
            console.log("FINAL FORMDATA:");
            for (let pair of fd.entries()) {
                console.log(pair[0], pair[1]);
            }

            // API
            const res = await updateLabEdit(fd);

            if (res.data.status === true) {
                toast.success(res.data.message);
                navigate("/lab");
            } else if (res.data.status === false) {
                toast.error(res.data.message);
            } else if (res.data.status === "expired") {
                toast.error(res.data.message);
                logout();
            }

        } catch (err) {
            toast.error(err?.response?.data?.message);
        } finally {
            setValue("isLoading", false);
        }
    };

    const isRejected = (key) => {
        return watch("objectionKeys")?.includes(key);
    };
    return (
        <>
            <Head title="Laboratory Details" />
            <Content>
                <style>{objectionStyles}</style>

                {/* Display rejected keys for debugging */}
                {data?.keys && data.keys.length > 0 && (
                    <div className="alert alert-danger mb-3">
                        <strong>Rejected Fields:</strong> {data.keys.join(", ")}
                    </div>
                )}

                <BlockHead size={"sm"}>
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                {"Laboratory"}
                            </BlockTitle>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="">
                                <Button
                                    color="primary"
                                    outline
                                    className={`me-n1`}
                                    onClick={() => {
                                        navigate("/lab");
                                    }}
                                >
                                    <Icon name={"arrow-left"} />
                                </Button>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <PreviewAltCard>
                        <Form onSubmit={handleSubmit(onFormSubmit)}>
                            <Row className=" ">
                                <div className="d-flex gap-5 py-3 mb-3">
                                    <h5>{"Lab & Diagnostics Profile"}</h5>
                                    <hr />
                                </div>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("name")}>
                                 <div className={isRejected("name") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Lab Name"
                                        name="name"
                                        placeholder="Enter your store full name"
                                        isObjection={getObjectionProp("name")}
                                    />
                                    </div>
                                </Col>

                                <Col md="3" lg="3" className={getFieldClassName("lab_type")}>
                                 <div className={isRejected("lab_type") ? "border border-danger rounded p-1" : ""}>
                                    <MySelect
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Lab Type"}
                                        name={"lab_type"}
                                        placeholder={"diagnostic center"}
                                        multi
                                        options={watch("labTypeDD")}
                                        isObjection={getObjectionProp("lab_type")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("pincode")}>
                                 <div className={isRejected("pincode") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Pin Code"}
                                        name={"pincode"}
                                        placeholder={"Enter pin code"}
                                        min={6}
                                        max={6}
                                        isObjection={getObjectionProp("pincode")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("state")}>
                                 <div className={isRejected("state") ? "border border-danger rounded p-1" : ""}>                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"State"}
                                        name={"state"}
                                        placeholder={"Select state"}
                                        isObjection={getObjectionProp("state")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("city")}>
                                 <div className={isRejected("city") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"City"}
                                        name={"city"}
                                        placeholder={"Select city"}
                                        isObjection={getObjectionProp("city")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("address")}>
                             <div className={isRejected("address") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Lab Full Address"}
                                        name={"address"}
                                        placeholder={"Enter enter lab full address"}
                                        isObjection={getObjectionProp("address")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("map_link")}>
                                    <div className={isRejected("map_link") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Google Map"}
                                        name={"map_link"}
                                        placeholder={"Enter google map link"}
                                        isObjection={getObjectionProp("map_link")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("person_name")}>
                                    <div className={isRejected("person_name") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Contact Person"}
                                        name={"person_name"}
                                        placeholder={"Enter contact person name"}
                                        isObjection={getObjectionProp("person_name")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("contact_number")}>
                                 <div className={isRejected("contact_number") ? "border border-danger rounded p-1" : ""}>
                                    <MyMobile
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Contact Number"}
                                        name={"contact_number"}
                                        placeholder={"Enter contact number"}
                                        isObjection={getObjectionProp("contact_number")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("mobile")}>
                                 <div className={isRejected("mobile") ? "border border-danger rounded p-1" : ""}>
                                    <MyMobile
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Mobile Number"}
                                        name={"mobile"}
                                        placeholder={"Enter mobile number"}
                                        isObjection={getObjectionProp("mobile")}
                                    />
                                     </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("alt_contact_number")}>
                                 <div className={isRejected("alt_contact_number") ? "border border-danger rounded p-1" : ""}>
                                    <MyMobile
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Alternate Contact Number"}
                                        name={"alt_contact_number"}
                                        placeholder={"Enter alter contact number"}
                                        isObjection={getObjectionProp("alt_contact_number")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("email")}>
                                 <div className={isRejected("email") ? "border border-danger rounded p-1" : ""}>
                                    <MyEmail
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Email Address"
                                        name="email"
                                        placeholder="Enter Email Address"
                                        required
                                        isObjection={getObjectionProp("email")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("latitude")}>
                                 <div className={isRejected("latitude") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Latitude"}
                                        name={"latitude"}
                                        placeholder={"Latitude"}
                                        required
                                        isObjection={getObjectionProp("latitude")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("longitude")}>
                                 <div className={isRejected("longitude") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Longitude"}
                                        name={"longitude"}
                                        placeholder={"Longitude"}
                                        required
                                        isObjection={getObjectionProp("longitude")}
                                    />
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <div className="d-flex gap-5 py-3 mb-3">
                                    <h5>{"Accreditation & Compliance"}</h5>
                                </div>

                                <Col xs="12" sm="6" md="4" lg="3">
                                    <div className="form-check mt-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="isNablCertified"
                                            {...register("isNablCertified")}
                                        />
                                        <label className="form-check-label" htmlFor="isNablCertified">
                                            NABL Certified
                                        </label>
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("nablId")}>
                                 <div className={isRejected("nablId") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="NABL ID"
                                        name="nablId"
                                        placeholder="Enter NABL ID"
                                        isObjection={getObjectionProp("nablId")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("nabl_certificate")}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="nabl_certificate"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"NABL Accreditation Certificate"}
                                        errors={errors}
                                        register={register}
                                        image={"nabl_certificate_img"}
                                        image_url={"nabl_certificate"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        validateDoc
                                        isObjection={getObjectionProp("nabl_certificate")}
                                    />
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("otherIds")}>
                                 <div className={isRejected("otherIds") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Other ID"
                                        name="otherIds"
                                        placeholder="Enter Other ID"
                                        isObjection={getObjectionProp("otherIds")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("other_certificate")}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="other_certificate"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"Other Certificate"}
                                        errors={errors}
                                        register={register}
                                        image={"other_certificate_img"}
                                        image_url={"other_certificate"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        validateDoc
                                        isObjection={getObjectionProp("other_certificate")}
                                    />
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("cmo_certificate")}>                              
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="cmo_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label="CMO Certificate"
                                        errors={errors}
                                        register={register}
                                        image="cmo"
                                        image_url="cmo_image"
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        validateDoc
                                        isObjection={getObjectionProp("cmo_certificate")}
                                    />
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("cmoNumber")}>
                                <div className={isRejected("cmoNumber") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="CMO Number"
                                        name="cmoNumber"
                                        placeholder="Enter Lab. Reg. number"
                                        required
                                        isObjection={getObjectionProp("cmoNumber")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("gstNumber")}>
                                <div className={isRejected("gstNumber") ? "border border-danger rounded p-1" : ""}>
                                    <MyGST
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="GST Number"
                                        name="gstNumber"
                                        placeholder="Enter gst number"
                                        isObjection={getObjectionProp("gstNumber")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("licenseNumber")}>
                                <div className={isRejected("licenseNumber") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="License Number"
                                        name="licenseNumber"
                                        placeholder="Enter License Number"
                                        isObjection={getObjectionProp("licenseNumber")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("pan")}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="pan_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"PAN Image"}
                                        errors={errors}
                                        register={register}
                                        image={"pan"}
                                        image_url={"pan_image"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        validateDoc
                                        isObjection={getObjectionProp("pan")}
                                    />
                                </Col>

                                {fields.map((field, index) => (
                                    <Col md="3" lg="3" key={field.id} className={getFieldClassName(`lab_license.${index}.certificate`, index)}>
                                        <ImageUpload
                                            getValues={getValues}
                                            id={`certificate_${index}`}
                                            watch={watch}
                                            trigger={trigger}
                                            setError={setError}
                                            clearErrors={clearErrors}
                                            errors={errors}
                                            register={register}
                                            label={`Lab License ${index + 1}`}
                                            image={`lab_license.${index}.certificate`}
                                            image_url={`lab_license.${index}.certificate_url`}
                                            setValue={setValue}
                                            handleImageOpenPreview={handleImageOpenPreview}
                                            validateDoc
                                            rm
                                            index={index}
                                            remove={remove}
                                            size={2048}
                                            isObjection={getObjectionProp("license_documents", index)}
                                        />
                                    </Col>
                                ))}

                                {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                                    <Col md="2">
                                        <Button
                                            style={{ marginTop: "30px" }}
                                            type="button"
                                            color="primary"
                                            className=" "
                                            id="addDegree"
                                            onClick={() => {
                                                append({ certificate: null, certificate_url: null });
                                            }}
                                        >
                                            {"Add License"}
                                        </Button>
                                    </Col>
                                )}
                            </Row>

                            <Row>
                                <div className="d-flex gap-5 py-3 mb-3">
                                    <h5>{"Service & Catalog"}</h5>
                                </div>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("service")}>
                                <div className={isRejected("service") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Service Type"
                                        name="service"
                                        placeholder="Enter service type"
                                        isObjection={getObjectionProp("service")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("startTime")}>
                                <div className={isRejected("startTime") ? "border border-danger rounded p-1" : ""}>
                                    <DateComponent
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Start Time"
                                        name="startTime"
                                        placeholder="start time"
                                        isObjection={getObjectionProp("startTime")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("endTime")}>
                                <div className={isRejected("endTime") ? "border border-danger rounded p-1" : ""}>
                                    <DateComponent
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="End Time"
                                        name="endTime"
                                        placeholder="end time"
                                        isObjection={getObjectionProp("endTime")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("radius")}>
                                <div className={isRejected("radius") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Service Area Radius"
                                        name="radius"
                                        placeholder="Enter service area radius"
                                        isObjection={getObjectionProp("radius")}
                                    />
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <div className="d-flex gap-5 py-3 mb-3">
                                    <h5>{"Bank & Documents"}</h5>
                                </div>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("bankName")}>
                                <div className={isRejected("bankName") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Bank Account Holder Name"
                                        name="bankName"
                                        placeholder="Enter bank account holder name"
                                        isObjection={getObjectionProp("bankName")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("accountNumber")}>
                                <div className={isRejected("accountNumber") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Account Number"
                                        name="accountNumber"
                                        placeholder="Enter account number"
                                        isObjection={getObjectionProp("accountNumber")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("ifscCode")}>
                                <div className={isRejected("ifscCode") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="IFSC Code"
                                        name="ifscCode"
                                        placeholder="Enter ifsc number"
                                        isObjection={getObjectionProp("ifscCode")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("upiId")}>
                                <div className={isRejected("name") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="UPI ID"
                                        name="upiId"
                                        placeholder="Enter UPI id number"
                                        isObjection={getObjectionProp("upiId")}
                                    />
                                    </div>
                                </Col>

                                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("passbook")}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="passbook_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"Bank Passbook /Cancelled Cheque"}
                                        errors={errors}
                                        register={register}
                                        image={"passbook"}
                                        image_url={"passbook_image"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        validateDoc
                                        isObjection={getObjectionProp("passbook")}
                                    />
                                </Col>

                                {labFields.map((field, index) => (
                                    <Col md="3" lg="3" key={field.id} className={getFieldClassName(`lab.${index}.image`, index)}>
                                        <ImageUpload
                                            getValues={getValues}
                                            id={`image_${index}`}
                                            watch={watch}
                                            trigger={trigger}
                                            setError={setError}
                                            clearErrors={clearErrors}
                                            errors={errors}
                                            register={register}
                                            label={`Lab Image ${index + 1}`}
                                            image={`lab.${index}.image`}
                                            image_url={`lab.${index}.image_url`}
                                            setValue={setValue}
                                            handleImageOpenPreview={handleImageOpenPreview}
                                            rm
                                            index={index}
                                            remove={labRemove}
                                            size={2048}
                                            isObjection={getObjectionProp("lab_images", index)}
                                        />
                                    </Col>
                                ))}

                                {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                                    <Col md="2">
                                        <Button
                                            style={{ marginTop: "30px" }}
                                            type="button"
                                            color="primary"
                                            className=" "
                                            id="addDegree"
                                            onClick={() => {
                                                labAppend({ image: null, image_url: null });
                                            }}
                                        >
                                            {"Add Image"}
                                        </Button>
                                    </Col>
                                )}
                            </Row>

                            <Row>
                                <div className="d-flex mt-5">
                                    <div className="form-group mx-2" style={{ marginTop: "31px" }}>
                                        <Button
                                            color="primary"
                                            size="md"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? <Spinner size="sm" color="light" /> : "Update"}
                                        </Button>
                                    </div>
                                </div>
                            </Row>
                        </Form>
                    </PreviewAltCard>
                </Block>
            </Content>
        </>
    );
};

export default LabDetails;